import { useTranslation } from "react-i18next";

export default MarkNotificationAsReadFailureToastContent;

function MarkNotificationAsReadFailureToastContent() {
  const { t } = useTranslation("mark-notification-as-read-toast");
  return t("failure");
}
